import React from 'react'
import axios from 'axios'
import Uploader from './../components/uploader'

class Theatre extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			headline: null,
			content: null,
			readyToSave: false,
			changesSaved: false,
			message: '',
			banner: null,
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'theatre',
				preview: true,
			}
		}).then( response => {
			this.setState({
				...this.state,
				headline: response.data.headline,
				content: response.data.content,
				banner: response.data.banner,
			})
		})
	}

	handleImageUploadComplete(imageURL){
		this.setState({
			banner: encodeURIComponent(imageURL),
			readyToSave: true
		})
	}

	handleSaveChanges(){
		const params = new URLSearchParams()
		params.append('filename', 'theatre')
		params.append('headline', this.state.headline)
		params.append('content', this.state.content)
		params.append('banner', this.state.banner)
		params.append('isDraft', 1)

		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com//api-admin.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			data: params,
		})
		.then( () => {
			this.setState({
				readyToSave: false,
				changedSaved: true,
				message: 'Preview Saved'
			})
		})
	}

	handleSubmit(e){
		// Kill default functionality.
		e.preventDefault()
		return false
	}

	handleUpdate(form){
		this.setState({
			...this.state,
			headline: encodeURIComponent(form.querySelector('.headline').value),
			content: encodeURIComponent(form.querySelector('.content').value),
			readyToSave: true,
		})
	}

	render() {
		return (
			<section className="container edit">
				<h2>Our Theatre</h2>
				{ this.state.readyToSave ?
					<button className="save button" onClick={this.handleSaveChanges.bind(this)}>Save Preview</button> :
					null
				}
				{ this.state.message.length ?
					<p className="message">{this.state.message}</p> :
					null
				}

				{  this.state.banner ?
					<img src={decodeURIComponent(this.state.banner)} className="banner" alt="theatre banner" /> :
					null
				}

				<Uploader
					className="banner_drop"
					uploadComplete={this.handleImageUploadComplete.bind(this)}
					label="Drop an image (or click) here to update banner"
				/>

				<form
					className="itemContainer"
					onChange={ e => {this.handleUpdate(e.target.closest('form'))} }
					onSubmit={() => this.handleSubmit()}>
						<input
							type="text"
							value={this.state.headline ? decodeURIComponent(this.state.headline) : ''}
							placeholder="Title"
							className="headline" />
						<textarea
							value={this.state.content ? decodeURIComponent(this.state.content) : ''}
							placeholder="Content"
							className="content"></textarea>
				</form>
			</section>
		)
	}
}

export default Theatre



// WEBPACK FOOTER //
// ./src/pages/theatre.js